const PUJA_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: "Pujas",
  url: "https://www.templedekho.com/pujas",
  hasPart: [
    {
      "@type": "WebPage",
      name: "Vivah Bandhan Sankalp",
      url: "https://www.templedekho.com/templePujaInfo?templeNameKey=Baba-Baidyanath-Dham&pujaNameKey=Gathbandhan-Puja%22",
    },
    {
      "@type": "WebPage",
      name: "Mahakal Raksha Naam Gotra Sankalp",
      url: "https://www.templedekho.com/templePujaInfo?templeNameKey=Mahakaleshwar-Jyotirlinga&pujaNameKey=Mahakal-Raksha-Naam-Gotra-Sankalp%22",
    },
    {
      "@type": "WebPage",
      name: "Karz Mukti Maha Havan (Debt Relief)",
      url: "https://www.templedekho.com/templePujaInfo?templeNameKey=Tarapith-Temple&pujaNameKey=Wrin-Mukti-Maha-Havan-Debt-Relief%22",
    },
    {
      "@type": "WebPage",
      name: "Navagraha Dosh Nivaran Pujan",
      url: "https://www.templedekho.com/templePujaInfo?templeNameKey=Navgrah-Shani-Temple-Ujjain&pujaNameKey=Navagraha-Dosh-Nivaran-Pujan%22",
    },
  ],
};

const PUJA_LIST_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "Popular Pujas",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Vivah Bandhan Sankalp",
      url: "https://www.templedekho.com/templePujaInfo?templeNameKey=Baba-Baidyanath-Dham&pujaNameKey=Gathbandhan-Puja%22",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Mahakal Raksha Naam Gotra Sankalp",
      url: "https://www.templedekho.com/templePujaInfo?templeNameKey=Mahakaleshwar-Jyotirlinga&pujaNameKey=Mahakal-Raksha-Naam-Gotra-Sankalp%22",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Karz Mukti Maha Havan (Debt Relief)",
      url: "https://www.templedekho.com/templePujaInfo?templeNameKey=Tarapith-Temple&pujaNameKey=Wrin-Mukti-Maha-Havan-Debt-Relief%22",
    },
    {
      "@type": "ListItem",
      position: 4,
      name: "Navagraha Dosh Nivaran Pujan",
      url: "https://www.templedekho.com/templePujaInfo?templeNameKey=Navgrah-Shani-Temple-Ujjain&pujaNameKey=Navagraha-Dosh-Nivaran-Pujan%22",
    },
  ],
};

export { PUJA_SCHEMA, PUJA_LIST_SCHEMA };
